import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { RenderHTML } from '@shared/ui-components/render-html/render-html';
import { MdrtFullLogo } from '@shared/ui-components/svgs';
import { useFormatTranslationString } from '@shared/utils/helpers/format-translation-string';
import { type MembershipInvoicePage } from '../../data/get-membership-invoice-page';
import styles from './contact-section.module.scss';
type ContactSectionProps = {
  membershipInvoicePageContent: MembershipInvoicePage;
  membershipYear: number;
};
export const ContactSection = t0 => {
  const $ = _c(18);
  const {
    membershipInvoicePageContent,
    membershipYear
  } = t0;
  const formatTranslationString = useFormatTranslationString();
  let t1;
  if ($[0] !== formatTranslationString || $[1] !== membershipInvoicePageContent.headerTitleText || $[2] !== membershipYear) {
    t1 = formatTranslationString(membershipInvoicePageContent.headerTitleText, {
      membershipApplicationYear: membershipYear
    });
    $[0] = formatTranslationString;
    $[1] = membershipInvoicePageContent.headerTitleText;
    $[2] = membershipYear;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const headerTitleLabel = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames(styles.section);
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== headerTitleLabel) {
    t3 = <p className={styles.section__title}>{headerTitleLabel}</p>;
    $[5] = headerTitleLabel;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={styles["section__logo-wrapper"]}><MdrtFullLogo className={styles.section__logo} /></div>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== membershipInvoicePageContent.headerAddressText) {
    t5 = <RenderHTML as="p" className={styles.section__address} html={membershipInvoicePageContent.headerAddressText} />;
    $[8] = membershipInvoicePageContent.headerAddressText;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== membershipInvoicePageContent.headerPhoneText) {
    t6 = <RenderHTML as="p" className={styles.section__phone} html={membershipInvoicePageContent.headerPhoneText} />;
    $[10] = membershipInvoicePageContent.headerPhoneText;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className={styles.section__contact}>{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t7) {
    t8 = <section className={t2}>{t3}{t4}{t7}</section>;
    $[15] = t3;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};